// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__tcy4T","summary":"CartItem_summary__h9nfh","price":"CartItem_price__FnFAG","amount":"CartItem_amount__9yL7d","actions":"CartItem_actions__zs7XU"};